/* =====================================================================================
   INCENTIVOS DEL CARRITO — 11 oct 2026 · assets/incentivos.js
   Se carga con defer desde layout/theme.liquid, ANTES de theme.js. No toca theme.js:
   escucha las respuestas de /cart*.js y de /cart/shipping_rates.json y, cuando el cajón
   ya se pintó, agrega encima lo suyo. Para quitarlo todo: borrar la línea del layout.

   Reglas (Amaury, 10 oct 2026):
     · Envío a domicilio en CDMX: gratis desde $2,500 en moto y $7,000 en auto/camioneta.
     · Recoger en Miramontes con esos mismos montos: atención prioritaria (el cliente
       elige la hora de su cita). Los demás agendan en horarios disponibles.
     · Regalo sorpresa (buff o vaso + sticker) en compras de moto desde $4,000. 50 piezas.
     · Alineación delantera gratis con 4 llantas rin 16+ Michelin, Pirelli, Bridgestone,
       Continental o Goodyear, instaladas en Miramontes. Vigencia: 31 dic 2026.

   INTERRUPTORES — el sitio no promete nada que el checkout no cumpla:
     ENVIO_GRATIS → prender SOLO cuando existan en Shopify las tarifas gratis por monto.
     PROMOS       → prender SOLO cuando existan los dos descuentos automáticos (BXGY).
     CITA_*_URL   → vacías = no se muestra nada de citas.
   Red de seguridad: si una línea de promo entra y Shopify NO la deja en $0, se quita sola
   y las promos se apagan en esa visita.

   Arreglo incluido (va prendido siempre): "Envío por cotizar" vale $0 en Shopify porque se
   cobra aparte, y theme.js lo tomaba como la tarifa más barata → pintaba "Gratis". Aquí se
   quita de la respuesta de tarifas antes de que theme.js la lea.
   ===================================================================================== */
(function(){
  'use strict';
  if(!window.fetch || !window.Response) return;

  var INC = {
    ENVIO_GRATIS: false,
    PROMOS: false,
    FIN: new Date('2026-12-31T23:59:59-06:00'),
    UMBRAL: { moto: 2500, auto: 7000 },
    REGALO_MOTO: 4000,
    ALIN_PIEZAS: 4,
    VAR_ALIN: 67660400197861,     // Alineación delantera — promo 4 llantas premium
    VAR_REGALO: 67660400230629,   // Regalo sorpresa Avante — compras de moto
    CITA_PRIORITARIA_URL: '',
    CITA_URL: '',
    BASES_URL: ''
  };
  /* Productos de la colección interna "promo-alineacion-interna" (225 al 11 oct 2026).
     Si cambia la colección, se regenera esta lista. */
  var ALIN = {};
  '9771841880293,9771844960485,9771878809829,9771878842597,9771882905829,9771883430117,9771883528421,9771883561189,9771883757797,9771883888869,9771884019941,9771884085477,9771884216549,9771884249317,9771884282085,9771884314853,9771884347621,9771884413157,9771884937445,9771885134053,9771885166821,9771885461733,9771885723877,9771885756645,9771885920485,9771886772453,9771887198437,9771887231205,9771888640229,9771888935141,9771889033445,9771889098981,9771891196133,9771891228901,9771891359973,9771891392741,9771891425509,9771891458277,9771891622117,9771891654885,9771891720421,9771891818725,9771891851493,9771891884261,9771891917029,9771892113637,9771892146405,9771892244709,9771892572389,9771892637925,9771892801765,9771892900069,9771892932837,9771892965605,9771892998373,9771893227749,9771893260517,9771893522661,9771893555429,9771893948645,9771893981413,9771894014181,9771894309093,9771894341861,9771894407397,9771894440165,9771894472933,9771894538469,9771894800613,9771895161061,9771895193829,9771895259365,9771895455973,9771895783653,9771895816421,9771895849189,9771895914725,9771896209637,9771896242405,9771896307941,9771896701157,9771896733925,9771897356517,9771897618661,9771898765541,9771899125989,9771899355365,9771899977957,9771900043493,9771900109029,9771900207333,9771900240101,9771900731621,9771900797157,9771900829925,9771900895461,9771900960997,9771901026533,9771901190373,9771901223141,9771901321445,9771901354213,9771901583589,9771901616357,9771901649125,9771901714661,9771901911269,9771901976805,9771902009573,9771902075109,9771902107877,9771902370021,9771902468325,9771902566629,9771902697701,9771902730469,9771902763237,9771902828773,9771903025381,9771903058149,9771903090917,9771903123685,9771903320293,9771903353061,9771903484133,9771903516901,9771903615205,9771903680741,9771903942885,9771904106725,9771904237797,9771904663781,9771905024229,9771905581285,9771906531557,9771906564325,9771906859237,9771906892005,9771906957541,9771907121381,9771907317989,9771907580133,9771908104421,9771908169957,9771908661477,9771908694245,9771908727013,9771908792549,9771908825317,9771909152997,9771909251301,9771909513445,9771909873893,9771910070501,9771910103269,9771910136037,9771910365413,9771910398181,9771910430949,9771910529253,9771912265957,9771912462565,9771912888549,9771912921317,9771912954085,9771913216229,9771913543909,9771913740517,9771914166501,9771914330341,9771914461413,9771914494181,9771914658021,9771914690789,9771914723557,9771914756325,9771914821861,9771914887397,9771914952933,9771915542757,9771915935973,9771917017317,9771918065893,9771918885093,9771919016165,9771919212773,9771919245541,9771919278309,9771920457957,9794740748517,9794741272805,9794742419685,9794745925861,9794747203813,9794749104357,9794749268197,9794749989093,9794750251237,9794751987941,9794752053477,9794753495269,9794753593573,9794753855717,9794756542693,9794756739301,9794757853413,9794757886181,9794757918949,9794758050021,9794758082789,9794758181093,15412765884645,15412766015717,15412766081253,15412766114021,15412766212325,15412766736613,15412767981797,15412768014565,15412768178405,15412769423589,15412771356901,15412771389669,15412771487973,15412775059685'.split(',').forEach(function(id){ ALIN[id] = 1; });

  var mx = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
  var _fetch = window.fetch.bind(window);
  var apagadas = false, ocupado = false, fallo = {}, ultimoAttr = null, timer = null;

  /* ---------- interceptor ---------- */
  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if(/\/cart\/shipping_rates\.json/.test(url)){
      p = p.then(function(r){
        if(!r.ok) return r;
        return r.clone().json().then(function(d){
          if(d && d.shipping_rates){
            d.shipping_rates = d.shipping_rates.filter(function(x){ return !/cotiz/i.test(x.name || ''); });
          }
          return new Response(JSON.stringify(d), { status: r.status, headers: { 'Content-Type': 'application/json' } });
        }).catch(function(){ return r; });
      });
    }
    if(/\/cart(\.js|\/)/.test(url)) p.then(function(){ programar(); }, function(){});
    return p;
  };
  function programar(){ clearTimeout(timer); timer = setTimeout(correr, 160); }
  function correr(){
    _fetch('/cart.js').then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){ if(c && c.items) incentivos(c); }).catch(function(){});
  }
  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('#drawer .delivery [data-del]')) programar();
  });
  document.addEventListener('input', function(e){
    if(e.target && e.target.id === 'cpInput') programar();
  });

  /* ---------- lectura del estado ---------- */
  function vigente(){ return new Date() <= INC.FIN; }
  function modo(){ var b = document.querySelector('#drawer .delivery [data-del].on'); return b ? b.getAttribute('data-del') : 'tienda'; }
  function cp(){ var i = document.getElementById('cpInput'); return i ? i.value.replace(/\D/g, '') : ''; }
  function cpCDMX(){ var c = cp(); if(c.length !== 5) return false; var n = +c.slice(0, 2); return n >= 1 && n <= 16; }
  function cpFuera(){ return cp().length === 5 && !cpCDMX(); }
  function segDe(it){
    var t = String(it.product_type || '').toLowerCase();
    if(t === 'moto') return 'moto';
    if(t === 'auto' || t === 'camioneta') return 'auto';
    return null;
  }
  function precio(it){ return ((it.final_line_price != null ? it.final_line_price : it.line_price) || 0) / 100; }
  function medir(cart){
    var r = { moto: 0, auto: 0, alin: 0, lineAlin: null, lineRegalo: null };
    (cart.items || []).forEach(function(it){
      if(it.variant_id === INC.VAR_ALIN){ r.lineAlin = it; return; }
      if(it.variant_id === INC.VAR_REGALO){ r.lineRegalo = it; return; }
      var s = segDe(it);
      if(s) r[s] += precio(it);
      if(ALIN[String(it.product_id)]) r.alin += it.quantity;
    });
    return r;
  }

  /* ---------- pintado ---------- */
  var css = document.createElement('style');
  css.textContent = '#incentivos{margin:10px 0 4px;display:grid;gap:8px}'
    + '#incentivos .inc{font-size:13px;line-height:1.35}'
    + '#incentivos .bar{height:6px;border-radius:3px;background:rgba(127,127,127,.25);margin-top:4px;overflow:hidden}'
    + '#incentivos .bar i{display:block;height:100%;background:currentColor;opacity:.75}'
    + '#incentivos .ok{font-weight:600}'
    + '#incentivos a{text-decoration:underline}'
    + '#incentivos .fine{font-size:11px;opacity:.75}'
    + '.litem.promo .qty{visibility:hidden}'
    /* theme.css pone display:flex a la caja de CP y a los renglones del total, y eso le gana
       al atributo hidden: al volver a "Recoger" seguían viéndose el CP y "Envío $450".
       Error que ya existía en el tema en vivo (comprobado el 11 oct 2026). */
    + '#drawer [hidden]{display:none!important}';
  (document.head || document.documentElement).appendChild(css);

  function caja(){
    var el = document.getElementById('incentivos');
    if(el) return el;
    var del = document.querySelector('#drawer .delivery');
    if(!del) return null;
    el = document.createElement('div');
    el.id = 'incentivos';
    el.setAttribute('aria-live', 'polite');
    del.parentNode.insertBefore(el, del.nextSibling);
    return el;
  }
  function barra(actual, meta, premio){
    var pct = Math.max(0, Math.min(100, Math.round(actual / meta * 100)));
    if(actual >= meta) return '<div class="inc ok">✓ ' + premio + '</div>';
    return '<div class="inc">Te faltan <b>' + mx.format(meta - actual) + '</b> para ' + premio
      + '<div class="bar"><i style="width:' + pct + '%"></i></div></div>';
  }
  /* theme.js pinta line_price (antes de descuento): la línea de promo saldría a $350.
     Aquí se marca como gratis y se esconden sus botones de cantidad. */
  function marcarLineasPromo(){
    [INC.VAR_ALIN, INC.VAR_REGALO].forEach(function(vid){
      var b = document.querySelector('#cartItems [data-vid="' + vid + '"]');
      var li = b && b.closest('.litem');
      if(!li) return;
      li.classList.add('promo');
      var p = li.querySelector('.p');
      if(p && p.textContent !== 'Gratis') p.textContent = 'Gratis';
    });
  }
  /* Vuelve a pintar el cajón con el código de theme.js: el botón de entrega ya activo
     dispara su fetchCart(). */
  function repintar(){
    var b = document.querySelector('#drawer .delivery [data-del].on');
    if(b) b.click();
  }

  /* ---------- líneas de promo ---------- */
  function post(url, body){
    return _fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }
  function ponerLinea(vid){
    ocupado = true;
    return post('/cart/add.js', { items: [{ id: String(vid), quantity: 1 }] })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('add ' + r.status)); })
      .then(function(){ return _fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        var l = (cart.items || []).filter(function(it){ return it.variant_id === vid; })[0];
        if(l && (l.final_line_price || 0) > 0){
          apagadas = true;
          if(window.console) console.warn('[incentivos] el descuento no dejó en $0 la variante', vid, '— promos apagadas');
          return post('/cart/change.js', { id: String(vid), quantity: 0 });
        }
      })
      .catch(function(){ fallo[vid] = true; })
      .then(function(){ ocupado = false; repintar(); });
  }
  function cambiar(vid, q){
    ocupado = true;
    return post('/cart/change.js', { id: String(vid), quantity: q })
      .catch(function(){})
      .then(function(){ ocupado = false; repintar(); });
  }
  function atributos(prioritaria){
    var v = prioritaria ? 'Sí — el cliente elige hora con el enlace de cita' : '';
    if(v === ultimoAttr) return;
    ultimoAttr = v;
    post('/cart/update.js', { attributes: { 'Atención prioritaria': v } }).catch(function(){});
  }

  /* ---------- el corazón ---------- */
  function incentivos(cart){
    var el = caja(); if(!el) return;
    var m = medir(cart);
    var tienda = modo() === 'tienda';
    var promos = INC.PROMOS && !apagadas && vigente();
    var html = [], txt = [];
    var hay = m.moto > 0 || m.auto > 0;

    [['moto', 'moto'], ['auto', 'auto y camioneta']].forEach(function(s){
      var sub = m[s[0]]; if(sub <= 0) return;
      var meta = INC.UMBRAL[s[0]];
      if(!tienda && INC.ENVIO_GRATIS && !cpFuera()){
        html.push(barra(sub, meta, 'envío gratis en CDMX (llantas de ' + s[1] + ')'));
        if(sub >= meta) txt.push('Envío gratis en CDMX (llantas de ' + s[1] + ')');
      }
      if(tienda && INC.CITA_PRIORITARIA_URL){
        html.push(barra(sub, meta, 'atención prioritaria: eliges la hora de tu cita'));
        if(sub >= meta) txt.push('Atención prioritaria en sucursal');
      }
    });
    if(!tienda && INC.ENVIO_GRATIS && hay && cpFuera()){
      html.push('<div class="inc fine">El envío gratis aplica solo dentro de la Ciudad de México.</div>');
    }

    var quiereRegalo = promos && m.moto >= INC.REGALO_MOTO && !fallo[INC.VAR_REGALO];
    var quiereAlin = promos && tienda && m.alin >= INC.ALIN_PIEZAS && !fallo[INC.VAR_ALIN];
    if(promos && m.moto > 0 && !fallo[INC.VAR_REGALO]){
      html.push(barra(m.moto, INC.REGALO_MOTO, 'tu <b>regalo sorpresa Avante</b>'));
      if(quiereRegalo) txt.push('Regalo sorpresa Avante');
    }
    if(promos && m.alin > 0 && !fallo[INC.VAR_ALIN]){
      if(!tienda){
        html.push('<div class="inc">La <b>alineación delantera gratis</b> aplica al instalar tus 4 llantas en Miramontes: elige <b>Recoger en tienda</b>.</div>');
      } else if(m.alin < INC.ALIN_PIEZAS){
        var faltan = INC.ALIN_PIEZAS - m.alin;
        html.push('<div class="inc">Agrega <b>' + faltan + ' llanta' + (faltan > 1 ? 's' : '') + '</b> premium rin 16+ y llévate la <b>alineación delantera gratis</b>'
          + '<div class="bar"><i style="width:' + Math.round(m.alin / INC.ALIN_PIEZAS * 100) + '%"></i></div></div>');
      } else {
        html.push('<div class="inc ok">✓ Alineación delantera gratis (valor regular $350 a $650 según vehículo)</div>');
        txt.push('Alineación delantera gratis');
      }
    }

    var prioritaria = tienda && !!INC.CITA_PRIORITARIA_URL
      && ((m.moto > 0 && m.moto >= INC.UMBRAL.moto) || (m.auto > 0 && m.auto >= INC.UMBRAL.auto));
    if(tienda && hay){
      if(prioritaria){
        html.push('<div class="inc"><a href="' + INC.CITA_PRIORITARIA_URL + '" target="_blank" rel="noopener">Elegir la hora de mi cita prioritaria →</a></div>');
      } else if(INC.CITA_URL){
        html.push('<div class="inc"><a href="' + INC.CITA_URL + '" target="_blank" rel="noopener">¿Vienes a instalar? Agenda tu cita →</a></div>');
      }
    }
    if(html.length && INC.BASES_URL && (promos || INC.ENVIO_GRATIS)){
      html.push('<div class="inc fine"><a href="' + INC.BASES_URL + '" target="_blank" rel="noopener">Bases y restricciones de las promociones</a></div>');
    }
    el.innerHTML = html.join('');
    el.hidden = !html.length;
    marcarLineasPromo();

    var wa = document.getElementById('cartWa');
    if(wa && txt.length && wa.href.indexOf('wa.me') > -1){
      /* Mismo formato que waLink() de theme.js: encodeURIComponent (espacios como %20, no +). */
      try {
        var partes = wa.href.split('?text='), t = partes[1] ? decodeURIComponent(partes[1]) : '';
        if(partes.length === 2 && t.indexOf('\nBeneficios: ') < 0){
          wa.href = partes[0] + '?text=' + encodeURIComponent(t + '\nBeneficios: ' + txt.join(' · '));
        }
      } catch(e){}
    }
    atributos(prioritaria);

    if(ocupado) return;
    if(quiereRegalo && !m.lineRegalo) return ponerLinea(INC.VAR_REGALO);
    if(!quiereRegalo && m.lineRegalo) return cambiar(INC.VAR_REGALO, 0);
    if(quiereAlin && !m.lineAlin) return ponerLinea(INC.VAR_ALIN);
    if(!quiereAlin && m.lineAlin) return cambiar(INC.VAR_ALIN, 0);
    if(m.lineRegalo && m.lineRegalo.quantity > 1) return cambiar(INC.VAR_REGALO, 1);
    if(m.lineAlin && m.lineAlin.quantity > 1) return cambiar(INC.VAR_ALIN, 1);
  }
})();
